import { useTranslation } from 'react-i18next'
import {
  ACTION_TEXT_BY_ITEM_STATUS,
  ACTION_TYPE_BY_ITEM_STATUS,
  ChangeHistoryItem,
  ITEM_STATES,
  ItemChanges,
  ItemChangesHistory,
  replacementItem,
  JobItem,
  ORIGIN_ITEM_CHANGES
} from '../../../domain/items'
import { State, useHookstate } from '@hookstate/core'
import { formatMoney } from 'accounting-js'
import { useEffect } from 'react'
import { Button, Col, Drawer, Row, Tabs } from 'antd'
import { ItemStatusSection } from './item-status-sectiton.component'
import { ItemChangesContainer } from './item-changes/item-changes-container.component'
import styled from 'styled-components'
import { VerticalLeftOutlined } from '@ant-design/icons'
import { JobItemCard } from './job-item-card/job-item-card.component'
import { PrintItemDrawer } from './print-item-list/print-item-drawer.component'
const { TabPane } = Tabs

const ItemDrawerSection = styled(Drawer)<{ showItemChangesSection: boolean }>`
  div.ant-drawer-content-wrapper {
    & > div {
      & > div {
        & > div:nth-child(1) {
          border-bottom-color: #f3f5f9;
          padding: 0;
          & > div {
            & > div {
              & > div:nth-child(1) {
                background-color: ${({ showItemChangesSection }) => (showItemChangesSection ? '#f3f5f9' : '#ffffff')};
                padding: 1.6rem 2.4rem;
              }
              & > div:nth-child(2) {
                background-color: #ffffff;
                padding: 1.6rem 2.4rem;
              }
            }
          }
        }
        & > div:nth-child(2) {
          padding: 0;
          & > div {
            height: 100%;
            & > div:nth-child(1) {
              background-color: ${({ showItemChangesSection }) => (showItemChangesSection ? '#f3f5f9' : '#ffffff')};
            }
            & > div:nth-child(2) {
              background-color: #ffffff;
            }
          }
        }
      }
    }
  }
`

const ItemChangesTitleSection = styled.div`
  & > div {
    & > div:nth-child(1) {
      & > label:nth-child(1) {
        display: block;
        color: #000000d9;
        font-size: 1.4rem;
        font-weight: 500;
      }
      & > label:nth-child(2) {
        display: block;
        color: #00000073;
        font-size: 1.2rem;
        font-weight: 500;
      }
    }
    & > div:nth-child(2) {
      text-align: center;
      margin: auto;
      & > span {
        cursor: pointer;
      }
    }
  }
`

const ItemDrawerTitleSection = styled.div`
  padding: 1rem;
`

const AddItemAndPrintItemsButtonSection = styled.div`
  margin: 1.6rem;
  padding: 1rem;
`

const ItemTabsSection = styled.div`
  margin: 1.6rem;
  padding: 1rem;
`

type ItemDrawerByJobProps = {
  items: State<JobItem[]>
  jobId: string
  currencyCode: string
  showItemDrawer: boolean
  clientLogoURL: string
  job: any
  onShowOrHideItemDrawer: (value: boolean) => void
}

const ItemDrawerByJob = (props: ItemDrawerByJobProps) => {
  const { items, jobId, currencyCode, showItemDrawer, clientLogoURL, job, onShowOrHideItemDrawer } = props
  const { t } = useTranslation()
  const showItemChangesSection = useHookstate<boolean>(false)
  const itemChanges = useHookstate<ItemChanges[]>([])
  const historyItems = useHookstate<ChangeHistoryItem[]>([])
  const itemsTabs = useHookstate<string[]>([])
  const filteredItemsByStatus = useHookstate<JobItem[]>([])
  const selectedItemsTab = useHookstate<string>('')
  const showItemPrintDrawer = useHookstate<boolean>(false)

  useEffect(() => {
    itemsTabs.set([])
    const itemStatus: string[][] = [
      [ITEM_STATES.PENDING],
      [ITEM_STATES.ADDED],
      [ITEM_STATES.REMOVED, ITEM_STATES.CANCELLED],
      [ITEM_STATES.REJECTED]
    ]
    showItemTabsByStatus(itemStatus)

    if (itemsTabs.get().length > 0) {
      selectedItemsTab.set(itemsTabs.get()[0])
    }
  }, [])

  useEffect(() => {
    if (itemChanges.get().length > 0) {
      getHistoryItems()
    }
  }, [itemChanges])

  useEffect(() => {
    const filteredItems = JSON.parse(JSON.stringify(items.get({ noproxy: true }))).filter((jobItem: JobItem) =>
      jobItem.status.includes(selectedItemsTab.get())
    )
    filteredItemsByStatus.set(filteredItems)
  }, [selectedItemsTab])

  const showItemTabsByStatus = (itemsStatus: string[][]): void => {
    itemsStatus.forEach((status: string[]) => {
      const itemsByStatus = items.get({ noproxy: true }).filter((item) => status.includes(item.status))

      if (itemsByStatus.length > 0) {
        itemsTabs.set([...itemsTabs.get({ noproxy: true }), status[0]])
      }
    })
  }

  const onChangeSelectedItemsTab = (key: string) => {
    if (key !== selectedItemsTab.get()) {
      filteredItemsByStatus.set([])
      selectedItemsTab.set(key)
    }
  }

  const getHistoryItems = () => {
    const changeHistoryItem: ChangeHistoryItem[] = []

    itemChanges.get({ noproxy: true }).forEach((itemChange: ItemChanges) => {
      itemChange.history
        .filter((history) => !history.replacedBy)
        .forEach((historyItem) => {
          const substitutedItems = []
          let historyItemStatus = null

          switch (historyItem.status) {
            case ITEM_STATES.PENDING:
            case ITEM_STATES.ADDED:
              historyItemStatus = getTheTextAndTypeOfTheItemPendingStatus(historyItem)

              break

            case ITEM_STATES.CANCELLED:
              historyItemStatus = getTheTextAndTypeOfTheItemCancelledStatus(historyItem)
              break

            case ITEM_STATES.REJECTED:
              historyItemStatus = getTheTextAndTypeOfTheItemRejectedStatus(historyItem)
              break

            case ITEM_STATES.CHANGED_ORIGINAL_QUANTITY:
              historyItemStatus = getTheTextAndTypeOfTheItemChangedOriginalStatus(historyItem)
              break

            default:
              historyItemStatus = {
                historyItemStatusType: ACTION_TYPE_BY_ITEM_STATUS[historyItem.status],
                historyItemStatusText: ACTION_TEXT_BY_ITEM_STATUS[historyItem.status]
              }
              break
          }

          if (historyItem.isSubstitute && historyItem.isSubstituteOf && historyItem.status !== ITEM_STATES.REMOVED) {
            let substitutedItem = JSON.parse(JSON.stringify(itemChanges.get())).find(
              (item) => item.itemId === historyItem.isSubstituteOf
            )

            if (substitutedItem) {
              substitutedItems.push(getChangeHistoryItem(substitutedItem))
            }
          }

          changeHistoryItem.push({
            changeBy: t<string>(historyItemStatus?.historyItemStatusText),
            date: `${new Date(historyItem.timestamp)}`,
            actionType: historyItemStatus?.historyItemStatusType,
            item: [getChangeHistoryItem(itemChange, historyItem.itemRejected, historyItem.status)],
            replacementItem: substitutedItems
          })
        })
    })

    historyItems.set(changeHistoryItem)
  }

  const getChangeHistoryItem = (substitutedItem: ItemChanges, itemRejected?: any, status?: string): replacementItem => {
    const { rejectedQuantity } = itemRejected || {}
    const price = `${t('jobs.job.info.items-view.product-card.price')}: ${formatMoney(
      substitutedItem.presentation.price,
      currencyCode
    )}`
    const rejectedDescription =
      rejectedQuantity && `${rejectedQuantity} ${substitutedItem.presentation.unit} ${t('of')}`
    const differentQuantity =
      status === ITEM_STATES.CHANGED_ORIGINAL_QUANTITY &&
      `${substitutedItem.foundQuantity} ${substitutedItem.presentation.unit} ${t('of')}`

    const description = `${rejectedDescription || differentQuantity || ''} ${substitutedItem.presentation.quantity} ${
      substitutedItem.presentation.unit
    } | ${price}`

    const ItemHistoryChanges: replacementItem = {
      id: substitutedItem.itemId,
      image: substitutedItem.photoUrl,
      name: substitutedItem.name,
      description
    }

    return ItemHistoryChanges
  }

  const getTheTextAndTypeOfTheItemPendingStatus = (historyItem: ItemChangesHistory) => {
    let statusItem = historyItem.status

    if (historyItem.origin === ORIGIN_ITEM_CHANGES.ODIN || historyItem.origin === ORIGIN_ITEM_CHANGES.CONTROL_TOWER) {
      statusItem = ACTION_TYPE_BY_ITEM_STATUS.ADDED_BY_AGENT
    }

    if (historyItem.origin === ORIGIN_ITEM_CHANGES.PICKER) {
      statusItem = historyItem.isSubstitute ? ACTION_TYPE_BY_ITEM_STATUS.REPLACED_BY_PICKER : ITEM_STATES.ADDED
    }

    if (historyItem.origin === ORIGIN_ITEM_CHANGES.BIFROST) {
      statusItem = ACTION_TYPE_BY_ITEM_STATUS.ADDED_BY_CLIENT
    }

    return {
      historyItemStatusType: ACTION_TYPE_BY_ITEM_STATUS[statusItem],
      historyItemStatusText: ACTION_TEXT_BY_ITEM_STATUS[statusItem]
    }
  }

  const getTheTextAndTypeOfTheItemCancelledStatus = (historyItem: ItemChangesHistory) => {
    let statusItem = historyItem.status

    if (
      historyItem.origin === ORIGIN_ITEM_CHANGES.ODIN ||
      historyItem.origin === ORIGIN_ITEM_CHANGES.CONTROL_TOWER ||
      historyItem.removedBy === ORIGIN_ITEM_CHANGES.AGENT
    ) {
      statusItem = ACTION_TYPE_BY_ITEM_STATUS.REMOVED_BY_AGENT
    }

    if (historyItem.origin === ORIGIN_ITEM_CHANGES.CLIENT) {
      statusItem = ACTION_TYPE_BY_ITEM_STATUS.REJECTED_BY_USER
    }

    return {
      historyItemStatusType: ACTION_TYPE_BY_ITEM_STATUS[statusItem],
      historyItemStatusText: ACTION_TEXT_BY_ITEM_STATUS[statusItem]
    }
  }

  const getTheTextAndTypeOfTheItemRejectedStatus = (historyItem: ItemChangesHistory) => {
    let statusItem = historyItem.status

    if (historyItem.origin === ORIGIN_ITEM_CHANGES.CLIENT) {
      statusItem = ACTION_TYPE_BY_ITEM_STATUS.REJECTED_BY_USER
    }

    return {
      historyItemStatusType: ACTION_TYPE_BY_ITEM_STATUS[statusItem],
      historyItemStatusText: ACTION_TEXT_BY_ITEM_STATUS[statusItem]
    }
  }

  const getTheTextAndTypeOfTheItemChangedOriginalStatus = (historyItem: ItemChangesHistory) => {
    let statusItem = historyItem.status

    statusItem = ITEM_STATES.ORIGINAL_QUANTITY_CHANGED_BY_PICKER

    return {
      historyItemStatusType: ACTION_TYPE_BY_ITEM_STATUS[statusItem],
      historyItemStatusText: ACTION_TEXT_BY_ITEM_STATUS[statusItem]
    }
  }

  const onShowOrHideItemPrintDrawer = (value: boolean): void => {
    showItemPrintDrawer.set(value)
  }

  return (
    <>
      <ItemDrawerSection
        showItemChangesSection={showItemChangesSection.get()}
        title={
          <Row>
            {showItemChangesSection.get() && (
              <Col span={10}>
                <ItemChangesTitleSection>
                  <Row>
                    <Col span={22}>
                      <label>{t<string>('changeHistory')}</label>
                      <label>{`${historyItems.get().length} ${t<string>('itemChangesHistoryTitle')}`}</label>
                    </Col>
                    <Col span={2}>
                      <VerticalLeftOutlined onClick={() => showItemChangesSection.set(false)} />
                    </Col>
                  </Row>
                </ItemChangesTitleSection>
              </Col>
            )}
            <Col span={showItemChangesSection.get() ? 14 : 24}>
              <ItemDrawerTitleSection>
                <Row>
                  <Col span={24}>
                    <label>{t<string>('jobs.job.info.items-view.title')}</label>
                  </Col>
                </Row>
              </ItemDrawerTitleSection>
            </Col>
          </Row>
        }
        width={showItemChangesSection.get() ? 1170 : 670}
        onClose={() => onShowOrHideItemDrawer(false)}
        visible={showItemDrawer}
      >
        <Row>
          {showItemChangesSection.get() && (
            <Col span={10}>
              <ItemChangesContainer historyItems={historyItems} />
            </Col>
          )}
          <Col span={showItemChangesSection.get() ? 14 : 24}>
            {showItemDrawer && (
              <ItemStatusSection
                items={items}
                jobId={jobId}
                showItemChangesSection={showItemChangesSection}
                itemChanges={itemChanges}
                historyItemsQuantity={historyItems.get().length}
              />
            )}

            <AddItemAndPrintItemsButtonSection>
              <Row gutter={16}>
                <Col span={12}>
                  <Button type='default' block onClick={() => onShowOrHideItemPrintDrawer(true)}>
                    {t<string>('jobs.job.info.items-view.print.title')}
                  </Button>
                </Col>
                <Col span={12}>
                  <Button type='primary' block>
                    {t<string>('jobs.job.info.items-view.add-item')}
                  </Button>
                </Col>
              </Row>
            </AddItemAndPrintItemsButtonSection>

            <ItemTabsSection>
              <Tabs activeKey={selectedItemsTab.get()} onTabClick={(key) => onChangeSelectedItemsTab(key)}>
                {itemsTabs.get().map((keyTab) => (
                  <TabPane tab={t(`jobs.job.info.items-view.${keyTab.toLocaleLowerCase()}`)} key={keyTab}>
                    {filteredItemsByStatus.get().length > 0 &&
                      filteredItemsByStatus.get().map((item: JobItem) => {
                        return (
                          <JobItemCard
                            item={item}
                            currencyCode={currencyCode}
                            selectedItemsTab={selectedItemsTab.get()}
                          />
                        )
                      })}
                  </TabPane>
                ))}
              </Tabs>
            </ItemTabsSection>
          </Col>
        </Row>
      </ItemDrawerSection>

      {showItemPrintDrawer.get() && (
        <PrintItemDrawer
          showItemPrintDrawer={showItemPrintDrawer}
          onShowOrHideItemPrintDrawer={onShowOrHideItemPrintDrawer}
          items={items}
          clientLogoURL={clientLogoURL}
          job={job}
        />
      )}
    </>
  )
}

export { ItemDrawerByJob }
